var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('popup-dialog',{attrs:{"title":"扫码支付"},on:{"close":_vm.close}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('vue-qr',{attrs:{"logo-src":require('@/assets/cf40.png'),"logo-scale":50,"text":_vm.qr_code,"size":350}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }